import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// GA4 sends page_view automatically only on the first load. This app is a SPA, so every
// in-app navigation needs an explicit page_view — otherwise Analytics reports 1 page per session.
export default function PageViewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}